module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_pensione.738dc5f5.png";